// Admin records and team export (architecture sprint-05 §6.2, §6.10).
import { keepPreviousData, useMutation, useQuery, type UseMutationResult, type UseQueryResult } from '@tanstack/react-query';
import { apiRequest, downloadFile } from '@/lib/api';
import { recordsApiQuery, recordsExportPath, type RecordsParams } from '@/lib/records-model';
import type { RecordsPage } from '@/types/admin';

export function useAdminRecords(params: RecordsParams): UseQueryResult<RecordsPage> {
  return useQuery({
    queryKey: ['admin', 'records', params],
    queryFn: () => apiRequest<RecordsPage>(`/api/admin/records?${recordsApiQuery(params)}`),
    placeholderData: keepPreviousData,
  });
}

export interface TeamExportRequest {
  params: RecordsParams;
  format: 'csv' | 'xlsx';
}

/** Not silent: EXPORT_TOO_LARGE uses the global toast with the server message. */
export function useTeamExport(): UseMutationResult<void, Error, TeamExportRequest> {
  return useMutation({
    mutationFn: ({ params, format }) =>
      downloadFile(recordsExportPath(params, format), `clockit-team-timesheet_${params.from}_${params.to}.${format}`),
  });
}
